module.exports = __webpack_public_path__ + "static/media/homeappliance.b598885f.svg";